// const API_URL = 'https://api.homologacao.grupogestorvidamg.com.br'
const API_URL = 'https://api.vidamg.com.br'
// const API_URL = 'https://apivida.agenciaportes.com.br'
// const API_URL = 'http://127.0.0.1:9000'


export default {
  API_URL: API_URL
}
